<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row class="sm-mt-5  flex-wrap">
       <v-col cols="12" md="6" class="d-flex flex-wrap course-filter justify-start">
          <v-btn color="secondary" outlined class="mr-1" to="/admin/reports/course">
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to Course Reports
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-start justify-md-end flex-wrap mt-2 mt-md-0 btn-wrapper"  v-if="serverItemsLength > 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" class="add-course-button" dark outlined v-bind="attrs" v-on="on">
                More
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item key="archiveData" @click.prevent="showCompletedUserPanel()">
                <v-list-item-title>Archive Course(s) Data</v-list-item-title>
              </v-list-item>
              <v-list-item key="email" @click.prevent="exportCsv('excel')">
                <v-list-item-title>Email Excel Report</v-list-item-title>
              </v-list-item>
              <v-list-item key="notcompleted" @click.prevent="showNotCompletedUserPanel()">
                <v-list-item-title>Mark Course(s) Completed</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
         </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            class="search-box"
            placeholder="Search Users By Name Or Email"
            prepend-icon="fa-search"
            v-model="search"
            type="text"
            clearable
            clear-icon="fa-times"
            @click:clear="resetSearch"
            @change="applySearch"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="users"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
              }"
            >
              <template
                v-slot:item.usercourses.last_completed_event_date="{ item }"
              >
                {{ item.usercourses.last_completed_event_date }}
              </template>
              <template v-slot:item.usercourses.progress="{ item }">
                {{ item.usercourses.progress }}%
                <!--<v-progress-linear
                  v-if="item.usercourses.state == 1"
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 2"
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 5"
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 3"
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear> -->
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom v-if="item.usercourses.progress == 100">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      @click.prevent="archiveUserCourse(item.usercourses.id)"
                    >
                      <v-icon small>fas fa-archive</v-icon>
                    </v-btn>
                  </template>
                  <span>Archive</span>
                </v-tooltip>
                <v-tooltip left v-if="item.usercourses.history_exists">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      @click.prevent="
                        showUserCourseHistoryPanel(item.usercourses.id)
                      "
                    >
                      <v-icon small>fas fa-history</v-icon>
                    </v-btn>
                  </template>
                  <span>View Completed Course History</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import userAPI from '@/api/user.js';
import courseAPI from '@/api/course.js';
import LayoutBasic from '@/layouts/Dashboard';
import ShowUserCourseHistory from '@/components/admin/course/ShowUserCourseHistory';
import CompletedUserPanel from '@/components/admin/course/CompletedUsers';
import NotCompletedUserPanel from '@/components/admin/course/NotCompletedUsers';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'CourseDetailsReport',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Enrolled Date', value: 'usercourses.enrolled_date_formatted', sortable: false },
        { text: 'Deadline', value: 'usercourses.deadline_formatted', sortable: false },
        { text: 'Started Date', value: 'usercourses.start_date_formatted', sortable: false },
        {
          text: 'Date Completed',
          value: 'usercourses.complete_date_formatted'
        },
        { text: 'Last Accessed', value: 'usercourses.last_accessed_date', sortable: false },

        { text: 'Progress', value: 'usercourses.progress'},
        { text: 'Test Score', value: 'usercourses.test_score', sortable: false },
        { text: 'Attempts', value: 'usercourses.attempts', sortable: false },
        { text: 'Agree Status', value: 'usercourses.is_agree', sortable: false },
        { text: 'Agreed By', value: 'usercourses.signed_name', sortable: false },
        { text: '', value: 'id', align: 'end', sortable: false },
      ],
      id: this.$route.params.id,
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      confirmArchive: 'Are you sure you wish to archive course for this user?',
      successMessage: 'Course Archived Successfully.',
      successExportMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {

      const options = { ...this.options }

      const sortFieldMap = {
        'usercourses.complete_date_formatted': 'complete_date_formatted',
        'usercourses.progress': 'progress'
      }

      if (Array.isArray(options.sortBy) && options.sortBy.length > 0) {
        const field = options.sortBy[0]

        if (sortFieldMap[field]) {
          options.sortBy = [sortFieldMap[field]]
        }
      }
      
      return (
        this.$gf.getQueryString(options, this.serverItemsLength) +
        this.searchParams +
        '&include='
      );
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getEnrolledUsers();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getEnrolledUsers() {
      this.loading = true;
      courseAPI
        .getCourseEnrolledUsers(this.id, this.params + 'usercourses')
        .then((resp) => {
          this.users = [];
          resp.data.data.forEach((item) => {
            item.usercourses = item.usercourses.data.filter((userCourse) => {
              return userCourse.course_id == this.id;
            });
            item.usercourses = item.usercourses[0];
            this.users.push(item);
          });
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = '';
      this.getEnrolledUsers();
    },
    applySearch() {
      if(this.search === null){
        this.searchParams = '';
        this.getEnrolledUsers();
      }else{
      this.searchParams =
        this.params +
        '&search=first_name:' +
        this.search +
        ';last_name:' +
        this.search  + ';email:' + this.search;
        this.getEnrolledUsers();
      }
    },
    exportCsv(type) {
      this.loading = true;
      courseAPI
        .exportEnrolledUsers(
          this.id,
          '?page=1&orderBy=&sortedBy=asc&limit=' +
            this.pagination.total +
            '&include=' +
            'usercourses' +
            '&type=' +
            type
        )
        .then((resp) => {
          this.$snotify.success(this.successExportMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    archiveUserCourse(id) {
      this.$snotify.confirm(this.confirmArchive, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processArchiveUserCourse(toast, id),
          },
        ],
      });
    },
    processArchiveUserCourse(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      courseAPI.archiveUserCourse(id).then(() => {
        this.getEnrolledUsers();
        this.$snotify.success(this.successMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    showUserCourseHistoryPanel(id) {
      this.$showPanel({
        component: ShowUserCourseHistory,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCompletedUserPanel(){
      this.$showPanel({
        component: CompletedUserPanel,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showNotCompletedUserPanel() {
      this.$showPanel({
        component: NotCompletedUserPanel,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    setEventBus() {
      EventBus.$on('COURSE_USERS_ARCHIVED', () => {
        this.getEnrolledUsers();
      });
    },
  },
};
</script>
<style scoped>
.email-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}

@media (max-width: 960px) {
  .email-button-wrapper {
    justify-content: start;
  }
}
</style>
